module.exports = __webpack_public_path__ + "img/leftDown.b41be2cb.png";